/**
 * versionControl.js — Application version and localStorage migration.
 *
 * Compares the stored app version against the current build version.
 * If they differ (i.e. the user has a stale session from a previous release),
 * all auth and cart data is wiped from localStorage to prevent stale-state bugs,
 * and the user is redirected to the home page.
 */

// ─── Constants ────────────────────────────────────────────────────────────────

/** Current application version string. Bump this on breaking schema changes. */
const store_version = '25.06';

// ─── Exported function ────────────────────────────────────────────────────────

/**
 * Checks whether the locally stored app version matches the current build.
 * If the versions differ, clears all session data and redirects to home.
 * Always writes the current version back to localStorage after the check.
 *
 * Called once at app startup (in index.js) before the React tree renders.
 */
export function checkAndResetLocalStorage() {
  const useStoreVersion = localStorage.getItem("store_version") !== null
    ? localStorage.getItem("store_version")
    : store_version;

  if (useStoreVersion !== undefined && store_version !== useStoreVersion) {
    // Version mismatch — clear all persisted data to avoid stale state.
    localStorage.removeItem("userDetail");
    localStorage.setItem('isLoggedin', false);
    localStorage.removeItem("checkout_token");
    localStorage.removeItem("thank_you_image");
    localStorage.removeItem("checkout_id");
    localStorage.removeItem("cart_session");
    localStorage.removeItem("create_account_detail");
    localStorage.removeItem("cart_session_sku");
    localStorage.removeItem("isLoggedin");
    localStorage.removeItem("was_book");
    localStorage.removeItem("wishlist_item");
    localStorage.removeItem("new_practice_area");
    localStorage.setItem("store_version", store_version);
    window.location.href = "/";
  } else {
    localStorage.setItem("store_version", store_version);
  }
}
